// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const ArrowBackward: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m9.347 5.635.713.688-5.158 5.158H21.02v1H4.884l5.152 5.158-.688.688L3 11.981l6.347-6.346Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

/* Store Custom Code - Start */
export const ArrowBackwardOffset: IconOffset = {
    vertical: 24,
    horizontal: 12,
};
/* Store Custom Code - End */

export default React.memo(ArrowBackward);
